import { skipToken } from '@reduxjs/toolkit/query';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { QUERY_KEY, parseQuery } from 'shared';
import { useGetConsumerApplicationsV1CreditApplicationsTokenTokenValidateQuery, } from 'consumer-applications-v1-api';
import { useIdentifierTracking } from 'hooks';
/**
 * Recovers the OTA context from the token in the URL. The OTA flow normally
 * threads practice/creditApplication/applicant/deliveryMethod through
 * react-router `location.state`, which a mobile browser drops when the app is
 * killed and the URL reloads as a fresh page. The token survives in the query
 * string, so this re-fetches the same details the state carried. RTK Query
 * caches by `{ token }`, so multiple callers on a page share one request.
 */
function useOtaTokenApplication() {
    const { search } = useLocation();
    const token = parseQuery(search)[QUERY_KEY.TOKEN];
    const { trackCreditApplicationId } = useIdentifierTracking();
    const { data: otaApplication, isFetching } = useGetConsumerApplicationsV1CreditApplicationsTokenTokenValidateQuery(token ? { token } : skipToken);
    const applicationId = otaApplication?.creditApplication?.applicationId;
    useEffect(() => {
        trackCreditApplicationId(applicationId, {
            componentName: 'useOtaTokenApplication',
            source: 'ota',
        });
    }, [applicationId, trackCreditApplicationId]);
    return { token, otaApplication, isFetching };
}
export default useOtaTokenApplication;
